<template>
    <div class="underlay">
        <transition mode="out-in" appear name="zoom">
            <div class="d-sm-flex justify-content-center align-items-center h-100">
                <div class="mb-sm-5">
                    <div class="login-card shadow mb-sm-5">
                        <b-row no-gutters>
                            <b-col sm="6">
                                <div class="p-5">
                                    <h4>Login</h4>
                                    <b-form>
                                        <div class="my-4">
                                            <div class="login-label">
                                                Email
                                            </div>
                                            <b-input
                                                class="login-input w-100"
                                                autocomplete="username"
                                                v-model="form.email"
                                                autofocus>
                                            </b-input>
                                        </div>
                                        <div class="my-4">
                                            <div class="login-label">
                                                Password
                                            </div>
                                            <b-input
                                                class="login-input w-100"
                                                type="password"
                                                v-model="form.password"
                                                @keyup.enter.native="onSubmit"
                                                autocomplete="current-password">
                                            </b-input>
                                        </div>
                                        <b-btn
                                            type="button"
                                            @click="onSubmit"
                                            variant="blue"
                                            class="login-button d-block w-100 mt-5 mx-0">
                                            Log In
                                        </b-btn>
                                    </b-form>
                                </div>

                            </b-col>
                            <div class="line vertical d-none d-sm-block"></div>
                            <div class="line horizontal d-sm-none"></div>
                            <b-col sm="6">
                                <div class="p-5 d-flex flex-column h-100 login-info">
                                    <img v-if="!LOGO_COLOR" class="logo img-fluid" src="@/assets/logo-sovrn.png">
                                    <img v-else class="logo img-fluid" :src="LOGO_COLOR">
                                    <p class="my-2 text-center">
                                        <!-- If you don't have an account, please contact us at {{ CONTACT_URL }} -->
                                      Interested in creating a Sovrn account? Visit <a href="https://sovrn.com" target="_blank">Sovrn.com</a> for more details.
                                    </p>

                                    <p class="my-2 text-center">
                                      <!-- If you don't have an account, please contact us at {{ CONTACT_URL }} -->
                                      Trouble logging in? Contact <a href="mailto:support@sovrn.com">support@sovrn.com</a> for assistance.
                                    </p>

                                    <!--
                                    <div class="mt-auto font-italic text-center">
                                        Don't have an account?
                                    </div>
                                    -->
                                    <div class="my-3 text-center">
                                        <a
                                            class="login-link"
                                            target="_blank"
                                            href="https://www.sovrn.com/privacy-policy">
                                             Privacy Policy
                                        </a>
                                    </div>

                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { UserApi } from '@/api'

export default {
  data () {
    return {
      LOGO_COLOR,
      CONTACT_URL,
      form: {
        email: null,
        password: null
      }
    }
  },
  methods: {
    onSubmit () {
      UserApi.accountLogin(this.form.email, this.form.password, this.redirectPath)
    }
  },
  computed: {
    redirectPath () {
      return this.$route.query.next
    }
  }
}
</script>

<style scoped>
.login-link {
    text-decoration: underline;
    font-weight: 500;
    color: var(--dark);
}
.login-info {
    font-size: 17px;
    line-height: 24px;
    color: var(--secondary);
}
.login-label {
    color: var(--medium);
    font-size: 14px;
    font-weight: 500;
}
.login-input {
    background-color: var(--light);
    border-color: var(--light);
    border-radius: 0;
}
.login-button {
    border-radius: 0;
    background-color: var(--blue);
    color: var(--white);
    font-weight: 500;
}
.login-card {
    position: relative;
    background-color: #fff;
    max-width: 700px;
}
.line.vertical {
    position: absolute;
    right: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
}
.line.horizontal {
    width: 100%;
    height: 1px;
}
.line {
    background-color: var(--border);
}
.overlay {
    position: relative;
    z-index: 1000;
}
.underlay {
    height: 100%;
    width: 100% !important;
    background: linear-gradient(126.9deg, #A300FF 0%, #00B8FF 100%);
    z-index: -1000;
}
.logo {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue